import React from 'react'
import { ContentStackTypes } from '../store/Constants'
import { SwitchToAMobileDeviceModal } from './SwitchToAMobileDeviceModal'

export const SwitchToAMobileDeviceModalGeneral = ({ open, onClose }) => {
  return (
    <SwitchToAMobileDeviceModal
      open={open}
      onClose={onClose}
      contentType={ContentStackTypes.switch_to_mobile_general}
    />
  )
}
